import React from 'react';
import { Route } from 'react-router-dom';
import { FlagGate } from '../features/featureFlags/components/FlagGate';
import { FeatureFlagName } from '../features/featureFlags/types';
import { WizardLayout } from '../layouts/WizardLayout';

const Wizard = React.lazy(() => import('../pages/Wizard').then((m) => ({ default: m.Wizard })));
const ImportWizardPage = React.lazy(() =>
  import('../features/recipeImport/pages/ImportWizardPage').then((m) => ({
    default: m.ImportWizardPage,
  })),
);

/** Recipe wizard routes — full-screen layout without AppMenu. */
export function wizardRoutes() {
  return (
    <Route element={<WizardLayout />}>
      <Route path="/wizard" element={<Wizard />} />
      <Route path="/wizard/:id" element={<Wizard />} />
      <Route
        path="/recipes/import"
        element={
          <FlagGate flag={FeatureFlagName.IMPORT_SOURCES} redirect="/catalog">
            <ImportWizardPage />
          </FlagGate>
        }
      />
    </Route>
  );
}
